import { defineExperiment } from '@cian/experiments/ab';

import { AUD_MOBILE_BX1170_SEARCH_STRING_AND_FF, AUD_WEB_BX1122_PIN_UNIFICATION } from './experiments';

export const ExpPinsAndPopupRedesign = defineExperiment(AUD_WEB_BX1122_PIN_UNIFICATION, {
  groups: ['A', 'B'] as const,
  default: 'A',
});

/**
 * Поисковая строка и редизайн быстрых фильтров на мобильном вебе. Фича раскатывается на группу B.
 *
 * Ветвиться нужно именно этим компонентом: он отправляет экспозицию — событие о том, что
 * пользователь увидел назначенную ему группу. Панель фильтров рендерится только под `<NotDesktop>`,
 * поэтому на десктопе эксперимент не монтируется и экспозиция оттуда не уходит.
 */
export const ExpSearchStringAndFastFilters = defineExperiment(AUD_MOBILE_BX1170_SEARCH_STRING_AND_FF, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
